import React, { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { Heading } from '../../components/heading';
import { Text } from '../../components/text';
import { useClients } from '../../contexts/DataContext';
import { usePortalView } from '../../contexts/PortalViewContext';
import PortalAfianzadorasList from '../../components/portal/PortalAfianzadorasList';

// Legacy standalone page. With an active fiado context the sidebar goes to the
// Empresa page instead, and this route redirects into its Afianzadoras tab so
// old bookmarks keep working. The no-context fallback (rare: non-client roles
// or accounts without contexts) keeps the aggregated list.
const ClientPortalAfianzadoras = () => {
  const { clientsList, clientsLoading } = useClients();
  const { activeClienteId } = usePortalView();

  const clients = useMemo(
    () => (activeClienteId ? clientsList.filter((c) => c.id === activeClienteId) : clientsList),
    [clientsList, activeClienteId]
  );

  if (activeClienteId) {
    return <Navigate to={`/app/portal/cliente/${activeClienteId}?tab=afianzadoras`} replace />;
  }

  if (clientsLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-azul-surelia" />
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-6 space-y-6">
      <div>
        <Heading level={1} className="text-azul-surelia">Afianzadoras</Heading>
        <Text className="text-zinc-600 mt-1">
          Líneas de afianzamiento, obligados solidarios y bienes en garantía.
        </Text>
      </div>
      <PortalAfianzadorasList clients={clients} />
    </div>
  );
};

export default ClientPortalAfianzadoras;
